export function toggleModalFormStatus(status) {
    const modalFormStatus = document.querySelector('.modal-form-status');

    if (status) {
        modalFormStatus.classList.remove('none');
        modalFormStatus.setAttribute('aria-modal', 'true');
    } else {
        modalFormStatus.removeAttribute('aria-modal');

        setTimeout(() => {
            modalFormStatus.classList.add('none');
            modalFormStatus.dataset.status = 'default';
        }, 350)
    }

    switch (status) {
        case 'success':
            modalFormStatus.dataset.status = 'success';
            break
        case 'error':
            modalFormStatus.dataset.status = 'error';
            break;
        default:
            break;
    }
}
